import api from "./api";

const resolverFiltros = (filtros = null) => filtros || {}

export const DashboardService = {
  buscarDadosPorUsuario: (idUsuario, filtros = null) => {
    return api.get(`perfil-usuario/usuario/dashboard/${idUsuario}`, { params: resolverFiltros(filtros) })
  },
  buscarDadosUsuarios: (filtros = null) => {
		return api.get(`/perfil-usuario/usuario/dashboard`, { params: resolverFiltros(filtros) })
	},

  buscarListaUsuarios: (filtros = null) => {
		return api.get(`/perfil-usuario/usuario/dashboard/metricas`, { params: resolverFiltros(filtros) })
	},

  buscarMetricasUsuario: (idUsuario, filtros = null) => {
		return api.get(`/perfil-usuario/usuario/dashboard/metricas/${idUsuario}`, { params: resolverFiltros(filtros) })
	},
};
